export var getTypographySize = function getTypographySize(layoutType, size) {
  if (size === 's') {
    switch (layoutType) {
      case 'tablet':
      case 'mobile':
        return 's';
      default:
        return 'm';
    }
  }
  switch (layoutType) {
    case 'tablet':
    case 'mobile':
      return 'm';
    default:
      return 'l';
  }
};